const ENV = process.env.NODE_ENV;
const HEROKU_BASE = "https://backend-ms-0446ad02a5ad.herokuapp.com/api";
const DEV_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

const runtimeUrl = (typeof window !== 'undefined' && (window.REACT_APP_API_URL || (window._env_ && window._env_.REACT_APP_API_URL))) || null;

const isProd = ENV === 'production';
const envApi = process.env.REACT_APP_API_URL;
const isLocalEnvApi = !!envApi && /(localhost|127\.0\.0\.1)/i.test(envApi);

let API_BASE_URL = isProd
  ? ((isLocalEnvApi ? null : envApi) || runtimeUrl || HEROKU_BASE)
  : DEV_BASE;

if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:' && typeof API_BASE_URL === 'string' && API_BASE_URL.startsWith('http://')) {
  API_BASE_URL = API_BASE_URL.replace(/^http:\/\//, 'https://');
}

export default API_BASE_URL;
